import React, {Component} from "react";
import {ORDER_ADMIN_ROUTE} from "../../../../utils/constants/RoutesConstants";
import UpdateOrderAdmin from "./UpdateOrderAdminView";
import {OrderAdminService} from "../../../../service/operation/orderAdmin/OrderAdminService";

export default class UpdateOrderAdminContainer extends Component {
    constructor(props) {
        super(props);

        this.orderAdminService = new OrderAdminService();

        this.loading = this.loading.bind(this);
        this.handleReturnButton = this.handleReturnButton.bind(this);
        this.saveDataOrderTrade = this.saveDataOrderTrade.bind(this);
        this.updateOrderAdmin = this.updateOrderAdmin.bind(this);
        this.updateRateAndSurchargeValue = this.updateRateAndSurchargeValue.bind(this);

        this.state = {
            isLoading: false,
            orderTrade: this.props.location.state.selectedOrderAdmin,
        };

        this.updateRateAndSurchargeValue();
    }

    loading(isLoading) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: isLoading
            });
        }
    }

    handleReturnButton(message) {
        this.props.history.push({
            pathname: ORDER_ADMIN_ROUTE,
            message: message,
        });
    }

    updateRateAndSurchargeValue() {
        let order = this.state.orderTrade;

        order.tasa = order.tasa * 100;
        order.sobreTasa = order.sobreTasa * 100;
        this.setState({
            orderTrade: order,
        })
    }

    saveDataOrderTrade(event) {
        const {name, value} = event.target;
        let orderTrade = this.state.orderTrade;
        orderTrade[name] = value;
        this.setState({orderTrade: orderTrade,})
    }

    updateOrderAdmin() {
        this.orderAdminService.updateOrderAdmin(
            this.state.orderTrade.idFolioPrest,
            this.state.orderTrade.idFolioValPrestable,
            this.state.orderTrade.idFolioSolVal,
            this.state.orderTrade.statusPv,
            this.state.orderTrade.cantidad,
            this.state.orderTrade.plazo,
            this.state.orderTrade.tasa,
            this.state.orderTrade.sobreTasa,
        ).then(
            res => {
                this.loading(false);
                if (res.message && res.message === 'Success') {
                    let message = {
                        severity: 'success',
                        summary: 'Éxito',
                        detail: 'Se ha actualizado la postura con éxito.',
                    };
                    this.handleReturnButton(message);
                } else if (res.error && res.error !== '') {
                    this.growl.show({
                        severity: 'error', summary: 'Error.',
                        detail: res.error
                    });
                }
            }
        );
    }

    render() {
        return <UpdateOrderAdmin
            isLoading={this.state.isLoading}
            handleReturnButton={this.handleReturnButton}
            saveDataOrderTrade={this.saveDataOrderTrade}
            orderTrade={this.state.orderTrade}
            updateOrderAdmin={this.updateOrderAdmin}
        />
    }
};